// Định nghĩa interface cho format mới (như trước)
interface ColumnDef {
    id: string;
    name: string;
  }
  
  interface DataPoint {
    id: string;
    name: string;
    values: Record<string, number>;
  }
  
  interface DashboardItem {
    id: string;
    name: string;
    type: "column" | "pie" | "content";
    displaySize: "1/3" | "2/3" | "3/3";
    columns?: ColumnDef[];
    data?: DataPoint[];
    contentHienTai?: string;
    contentTuongLai?: string;
  }
  
  interface OldItem {
    Ten?: string;
    DonVi?: string;
    HienThi?: string;
    GiaTris?: Array<{ Ten: string; GiaTri: number[] }>;
    Texts?: string[];
    HienTai?: string;
    TuongLai?: string;
  }
  
  interface DashboardJson {
    QuyMos: DashboardItem[];
    ThiPhans: DashboardItem[];
    PhanKhucs: any[];
    NhomSanPhams: any[];
  }
  
  // Hàm chuyển đổi section (như trước, giữ nguyên)
  function convertSection(items: OldItem[], sectionName: string): DashboardItem[] {
    return items.map((oldItem, index) => {
      const newId = `${sectionName}-${Date.now()}-${index}`;
  
      const isTextOnly =
        oldItem.DonVi === "text" ||
        (oldItem.GiaTris?.length ?? 0) === 0 ||
        (oldItem.Texts?.length ?? 0) === 0;
  
      if (isTextOnly) {
        return {
          id: newId,
          name: oldItem.Ten || "Thông tin chiến lược / Thị phần",
          type: "content",
          displaySize: "3/3",
          columns: [{ id: "col1", name: "" }],
          data: [
            { id: "1", name: "", values: { col1: 0 } },
            { id: "2", name: "", values: { col1: 0 } },
          ],
          contentHienTai: oldItem.HienTai?.trim() || "",
          contentTuongLai: oldItem.TuongLai?.trim() || "",
        };
      }
  
      const texts = oldItem.Texts || [];
      const columns: ColumnDef[] = texts.map((text, idx) => ({
        id: `col${idx + 1}`,
        name: text.trim() || `Nhóm ${idx + 1}`,
      }));
  
      const data: DataPoint[] = (oldItem.GiaTris || []).map((yearItem, idx) => {
        const values: Record<string, number> = {};
        yearItem.GiaTri.forEach((val, colIdx) => {
          values[`col${colIdx + 1}`] = val ?? 0;
        });
        return {
          id: `${idx + 1}`,
          name: yearItem.Ten.trim() || `Năm ${2024 + idx}`,
          values,
        };
      });
  
      return {
        id: newId,
        name: oldItem.Ten?.trim() || "Biểu đồ tăng trưởng",
        type: "column",
        displaySize: columns.length <= 2 ? "1/3" : columns.length === 3 ? "1/3" : "2/3",
        columns,
        data,
      };
    });
  }
  
  // Hàm chính: kiểm tra trước rồi mới chuyển
  export function safeConvertOldJsonToNewFormat(inputJson: any): DashboardJson | any {
    // Nếu không phải object hợp lệ
    if (!inputJson || typeof inputJson !== 'object') {
      return inputJson; // giữ nguyên
    }
  
    // Kiểm tra format cũ
    if (isOldJsonFormat(inputJson)) {
      return {
        QuyMos: convertSection(inputJson.QuyMos || [], "quymos"),
        ThiPhans: convertSection(inputJson.ThiPhans || [], "thiphans"),
        PhanKhucs: inputJson.PhanKhucs || [],
        NhomSanPhams: inputJson.NhomSanPhams || [],
      };
    } else {
      return inputJson; // giữ nguyên nếu đã là format mới hoặc không khớp
    }
  }

  // Hàm kiểm tra xem object có phải format cũ (JSON 1) hay không
export function isOldJsonFormat(json: any): boolean {
    if (!json || typeof json !== 'object') return false;
  
    // Kiểm tra các key chính phải tồn tại
    const requiredTopKeys = ['QuyMos', 'ThiPhans', 'PhanKhucs', 'NhomSanPhams'];
    if (!requiredTopKeys.every(key => key in json)) return false;
  
    // Kiểm tra QuyMos (ít nhất 1 item) có cấu trúc cũ
    if (!Array.isArray(json.QuyMos) || json.QuyMos.length === 0) return false;
  
    const firstQuyMo = json.QuyMos[0];
    if (
      !('Ten' in firstQuyMo) ||
      !('DonVi' in firstQuyMo) ||
      !('HienThi' in firstQuyMo) ||
      !('GiaTris' in firstQuyMo) ||
      !Array.isArray(firstQuyMo.GiaTris) ||
      !('Texts' in firstQuyMo) ||
      !Array.isArray(firstQuyMo.Texts) ||
      !('HienTai' in firstQuyMo) ||
      !('TuongLai' in firstQuyMo)
    ) {
      return false;
    }
  
    // Kiểm tra ThiPhans cũng có cấu trúc tương tự (text-based)
    if (Array.isArray(json.ThiPhans) && json.ThiPhans.length > 0) {
      const firstThiPhan = json.ThiPhans[0];
      if (
        !('DonVi' in firstThiPhan) ||
        !('HienTai' in firstThiPhan) ||
        !('TuongLai' in firstThiPhan)
      ) {
        return false;
      }
    }
  
    // Nếu có các trường đặc trưng của format mới (như type: "column", columns, data) → không phải format cũ
    if ('type' in firstQuyMo || 'columns' in firstQuyMo || 'data' in firstQuyMo) {
      return false;
    }
  
    return true;
  }